import * as React from "react"
import { AlertCircle, CheckCircle2, Info } from "lucide-react"
import { cn } from "../../lib/utils"

type AlertTone = "danger" | "success" | "info"

const toneStyles: Record<AlertTone, { box: string; Icon: typeof Info }> = {
  danger: { box: "border-danger/25 bg-danger/10 text-[#ffb4b4]", Icon: AlertCircle },
  success: { box: "border-success/25 bg-success/10 text-[#a6efcb]", Icon: CheckCircle2 },
  info: { box: "border-info/25 bg-info/10 text-[#b5d8ff]", Icon: Info },
}

interface AlertProps extends React.ComponentProps<"div"> {
  tone?: AlertTone
}

function Alert({ tone = "danger", className, children, ...props }: AlertProps) {
  const { box, Icon } = toneStyles[tone]
  return (
    <div
      role={tone === "danger" ? "alert" : "status"}
      className={cn("flex items-start gap-2.5 rounded-lg border px-3 py-2.5 text-[13px]", box, className)}
      {...props}
    >
      <Icon className="mt-px size-4 shrink-0" />
      <div className="min-w-0">{children}</div>
    </div>
  )
}

export { Alert }
